/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgBooleanBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 14"
    fill="none"
    {...props}
  >
    <path
      d="M23.0001 7C23.0001 3.54824 20.2019 0.75 16.7501 0.75H7.05277C3.60097 0.75 0.802734 3.54824 0.802734 7C0.802734 10.4518 3.60097 13.2501 7.05277 13.2501H16.7501C20.2019 13.2501 23.0001 10.4518 23.0001 7Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
    <path
      d="M20.1772 7.0001C20.1772 4.86801 18.4488 3.13965 16.3168 3.13965C14.1847 3.13965 12.4564 4.86801 12.4564 7.0001C12.4564 9.1321 14.1847 10.8605 16.3168 10.8605C18.4488 10.8605 20.1772 9.1321 20.1772 7.0001Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
  </svg>
);
const SvgBoolean = wrapIcon(SvgBooleanBase);
export default SvgBoolean;
